import { TxnAction } from './TxnAction';
import { JsonTxnBuilder } from '../builders';

class TxnMergeAction extends TxnAction {
  isReplaceTxn(txn) {
    return txn.stepType === 'replace';
  }

  isTxnOfSameType(txn1, txn2) {
    return txn1.stepType === txn2.stepType;
  }

  shouldMerge(txn1, txn2) {
    if (this.isTxnOfSameType(txn1, txn2)) {
      if (this.isReplaceTxn(txn1) && txn1.to === txn2.from - 1) {
        return true;
      }
    }
    return false;
  }

  performAction(txns) {
    super.performAction(txns);
    // if (txns.length === 0 || txns.length === 1) return txns;
    // const output = [txns[0]];
    // let k = 0;
    // for (let i = 1; i < txns.length; i++) {
    //   let currentTxn = txns[i];
    //   const prevTxn = output[k];
    //   const shouldmerge = this.shouldMerge(prevTxn, currentTxn);
    //   if (shouldmerge) {
    //     const from = prevTxn.from;
    //     const to = currentTxn.to;
    //     const stepType = currentTxn.stepType;
    //     const content = [...(prevTxn?.slice?.content || []), ...(currentTxn?.slice?.content || [])];
    //     currentTxn = {
    //       stepType,
    //       from,
    //       to,
    //       ...(currentTxn?.structure && { structure: currentTxn.structure }),
    //       ...(content?.length > 0 && { slice: { content } }),
    //     };
    //     output.pop();
    //     k--;
    //   }
    //   output.push(currentTxn);
    //   k++;
    // }
    // return output;
    return txns;
  }
}

export { TxnMergeAction };
